import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Dialog } from '@factorialco/f0-react'
import { EmployeesEmployeeSelectorInput } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import { useBulkCreatePolicyAssignments } from 'modules/timeoff/hooks/useBulkCreatePolicyAssignments'

interface Props {
  loading: boolean
  timeoffPolicyId: number
  timeoffPolicyEmployeeIds: number[]
  onClose: () => void
}

const AddEmployeeAssignment = ({
  loading,
  timeoffPolicyId,
  timeoffPolicyEmployeeIds,
  onClose,
}: Props) => {
  const [selectedEmployees, setSelectedEmployees] = useState<EmployeesEmployeeSelectorInput>({
    type: 'manual',
    ids: [],
  })

  const { loading: loadingBulkCreate, create: bulkCreate } = useBulkCreatePolicyAssignments({
    onCompleted(data) {
      if (data.timeoffMutations.bulkCreateTimeoffCurrentPolicyAssignment?.errors.length) {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('settings.timeoff_policies.add_employees_modal.assign.error'),
          time: 2000,
        })
      } else {
        app.setFlash({
          type: 'correct',
          message: i18n.t('common.saved_successfully'),
          time: 2000,
        })
      }
    },
  })

  const addEmployees = async () => {
    await bulkCreate({
      employeeSelection: selectedEmployees,
      timeoffPolicyId,
    })
    onClose()
  }

  return (
    <F0Dialog
      isOpen
      width="sm"
      onClose={() => {
        if (loadingBulkCreate) return
        onClose()
      }}
      title={i18n.t('settings.timeoff_policies.add_employees_modal.assign.title')}
      description={i18n.t('settings.timeoff_policies.add_employees_modal.assign.description')}
      primaryAction={{
        label: i18n.t('settings.timeoff_policies.add_employees_modal.button'),
        onClick: addEmployees,
        disabled: selectedEmployees?.ids?.length === 0 || loading || loadingBulkCreate,
        loading: loadingBulkCreate,
      }}
    >
      {loadingBulkCreate || loading ? (
        <Loading />
      ) : (
        <Box gap="s16" flexDirection="column">
          <EmployeeSelectorV2
            messages={{
              placeholder: i18n.t('settings.timeoff_policies.add_employees_modal.assign.title'),
            }}
            forcedFilters={{
              excludeIds: timeoffPolicyEmployeeIds,
            }}
            onChange={setSelectedEmployees}
            options={{
              hideSearchIcon: true,
              hideLabel: true,
            }}
            multiple
          />
        </Box>
      )}
    </F0Dialog>
  )
}

export default observer(AddEmployeeAssignment)
